import {AbstractService} from "@/services/AbstractService";

export abstract class AbstractHttpRequestObserver extends AbstractService
{
    abstract isApplicable(method: string, url: string): boolean
    abstract resolve(method: string, url: string, responseSource: string, response: null|Record<any, any>): void
}
